<template>
    <div class="gs-thankyou-tab">
        <div class="gs-thankyou-note">
            <info-icon class="h-4 w-4 fill-current"/>
            <span>{{ $t('frontend_product_step4_note') }}</span>
        </div>

        <div class="gs-thankyou-list">
            <article
                v-for="(pricePoint, index) in Localpricing_points"
                :key="pricePoint.id || index"
                class="gs-thankyou-item"
                :class="{
                    'is-active': activePricePointId === pricePointId(pricePoint, index),
                    'has-error': thankYouValidation(index).$error,
                }"
            >
                <button type="button" class="gs-thankyou-item__head" :aria-expanded="activePricePointId === pricePointId(pricePoint, index)" @click="togglePricePoint(pricePoint, index)">
                    <div>
                        <span class="gs-thankyou-item__title-row">
                            <strong>{{ pricePoint.name }}</strong>
                            <small
                                class="gs-thankyou-item__mode"
                                :class="{ 'is-dynamic': dynamicThankYou(pricePoint).enabled }"
                            >
                                {{ dynamicThankYou(pricePoint).enabled ? 'Dynamic thank-you page' : 'Static URL' }}
                            </small>
                        </span>
                        <span>{{ thankYouUrlSummary(pricePoint) }}</span>
                    </div>
                    <em>{{ activePricePointId === pricePointId(pricePoint, index) ? 'Editing' : 'Edit' }}</em>
                    <gs-icon :name="activePricePointId === pricePointId(pricePoint, index) ? 'chevron-up' : 'chevron-down'" size="18"></gs-icon>
                </button>

                <div v-if="activePricePointId === pricePointId(pricePoint, index)" class="gs-thankyou-item__body">
                    <div class="gs-thankyou-options">
                        <button
                            type="button"
                            :class="{ 'is-selected': dynamicThankYou(pricePoint).enabled }"
                            @click="setDynamicThankYou(pricePoint, true)"
                        >
                            Dynamic thank-you page
                        </button>
                        <button
                            type="button"
                            :class="{ 'is-selected': !dynamicThankYou(pricePoint).enabled }"
                            @click="setDynamicThankYou(pricePoint, false)"
                        >
                            Custom URL
                        </button>
                    </div>
                    <div v-if="dynamicThankYou(pricePoint).enabled" class="gs-thankyou-dynamic">
                        <label>
                            <span>Headline</span>
                            <text-input
                                v-model="pricePoint.post_checkout_details.dynamic_thank_you_page.headline"
                                value="pricePoint.post_checkout_details.dynamic_thank_you_page.headline"
                                placeholder="Thank you for your order"
                            />
                        </label>
                        <label>
                            <span>Message</span>
                            <text-area
                                v-model="pricePoint.post_checkout_details.dynamic_thank_you_page.body"
                                value="pricePoint.post_checkout_details.dynamic_thank_you_page.body"
                                placeholder="Your order is confirmed. You can review your purchase details below."
                            />
                        </label>
                    </div>
                    <label class="gs-thankyou-url">
                        <span>{{ dynamicThankYou(pricePoint).enabled ? 'Fallback thank-you URL' : $t('frontend_product_step4_thank_you') }}</span>
                        <text-input v-model="pricePoint.post_checkout_details.thankyou_page"
                            :validator="thankYouValidation(index)"
                            :attribute="$t('frontend_product_step4_thankyou_page')"
                            value="pricePoint.post_checkout_details.thankyou_page"
                            :placeholder="$t('frontend_product_step4_thank_you')" />
                        <small v-if="thankYouValidation(index).$error" class="gs-thankyou-url__error">
                            Enter a complete URL beginning with https://, or choose a dynamic thank-you page.
                        </small>
                    </label>
                </div>
            </article>
        </div>
    </div>
</template>
<script>
import InfoIcon from '@/assets/images/icons/InfoIcon.svg';

export default {
    components: {
        InfoIcon,
    },
    props: {
        pricing_points: {
            required: true,
        },
        validation: {
            required: true,
        },
    },
    data() {
        return {
            Localpricing_points: this.pricing_points,
            activePricePointId: this.pricing_points[0] ? (this.pricing_points[0].id || 'price-point-0') : null,
        };
    },
    watch: {
        Localpricing_points: {
            handler() {
                this.validation.localModel.pricing_points.$touch();
                this.$emit('update-model', {
                    pricing_points: this.Localpricing_points
                });
            },
            deep: true,
        },
    },
    methods: {
        dynamicThankYou(pricePoint) {
            if (!pricePoint.post_checkout_details.dynamic_thank_you_page) {
                this.$set(pricePoint.post_checkout_details, 'dynamic_thank_you_page', {
                    enabled: false,
                    headline: 'Thank you for your order',
                    body: 'Your order is confirmed. You can review your purchase details below.',
                });
            }

            return pricePoint.post_checkout_details.dynamic_thank_you_page;
        },

        setDynamicThankYou(pricePoint, enabled) {
            const dynamicThankYou = this.dynamicThankYou(pricePoint);
            dynamicThankYou.enabled = enabled;
            if (enabled && !dynamicThankYou.headline) {
                dynamicThankYou.headline = 'Thank you for your order';
            }
        },
        pricePointId(pricePoint, index) {
            return pricePoint.id || `price-point-${index}`;
        },
        togglePricePoint(pricePoint, index) {
            this.activePricePointId = this.activePricePointId === this.pricePointId(pricePoint, index)
                ? null
                : this.pricePointId(pricePoint, index);
        },
        thankYouUrlSummary(pricePoint) {
            return pricePoint.post_checkout_details && pricePoint.post_checkout_details.thankyou_page
                ? pricePoint.post_checkout_details.thankyou_page
                : 'No thank-you URL set';
        },
        thankYouValidation(index) {
            return this.validation.localModel.pricing_points.$each[index].post_checkout_details.thankyou_page;
        },
    },

}
</script>
<style>
.gs-thankyou-tab {
    color: var(--gs-foreground);
}

.gs-thankyou-note {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 18px;
    padding: 10px 12px;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    line-height: 1.4;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
}

.gs-thankyou-list {
    display: grid;
    gap: 10px;
}

.gs-thankyou-item {
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
    box-shadow: var(--gs-shadow-sm);
}

.gs-thankyou-item.is-active {
    background: var(--gs-active-soft);
    border-color: var(--gs-active);
    box-shadow: 0 0 0 3px var(--gs-active-shadow), var(--gs-shadow-sm);
}

.gs-thankyou-item.has-error {
    border-color: var(--gs-danger-border);
}

.gs-thankyou-item__head {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto 18px;
    gap: 14px;
    align-items: center;
    width: 100%;
    min-height: 72px;
    padding: 14px 16px;
    text-align: left;
    background: transparent;
    border: 0;
    cursor: pointer;
}

.gs-thankyou-item__title-row {
    display: flex !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 0 !important;
}

.gs-thankyou-item__head strong {
    display: inline-block;
    color: var(--gs-foreground);
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
}

.gs-thankyou-url__error {
    display: block;
    margin-top: 7px;
    color: var(--gs-danger);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.45;
}

.gs-thankyou-item__mode {
    display: inline-flex !important;
    align-items: center;
    min-height: 24px;
    margin: 0 !important;
    padding: 0 9px;
    color: var(--gs-muted-foreground) !important;
    font-size: 12px !important;
    font-weight: 700;
    line-height: 1;
    letter-spacing: .01em;
    white-space: nowrap;
    background: var(--gs-muted);
    border: 1px solid var(--gs-border);
    border-radius: 999px;
}

.gs-thankyou-item__mode.is-dynamic {
    color: var(--gs-success) !important;
    background: var(--gs-success-soft);
    border-color: var(--gs-success);
}

.gs-thankyou-item__head span {
    display: block;
    margin-top: 4px;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    line-height: 1.4;
    overflow-wrap: anywhere;
}

.gs-thankyou-item__head em {
    padding: 8px 12px;
    color: var(--gs-muted-foreground);
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
}

.gs-thankyou-item.is-active .gs-thankyou-item__head em {
    color: var(--gs-active);
    border-color: var(--gs-active-border);
}

.gs-thankyou-item__body {
    padding: 0 16px 18px;
}

.gs-thankyou-options {
    display: inline-flex;
    gap: 8px;
    margin: 0 0 16px;
    padding: 4px;
    background: var(--gs-muted);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-thankyou-options button {
    padding: 8px 12px;
    color: var(--gs-muted-foreground);
    font-size: 12px;
    font-weight: 700;
    background: transparent;
    border: 0;
    border-radius: var(--gs-radius-md);
    cursor: pointer;
}

.gs-thankyou-options button.is-selected {
    color: var(--gs-active);
    background: var(--gs-surface);
    box-shadow: var(--gs-shadow-sm);
}

.gs-thankyou-dynamic {
    display: grid;
    gap: 14px;
    margin-bottom: 18px;
}

.gs-thankyou-dynamic label,
.gs-thankyou-url {
    display: grid;
    gap: 8px;
}

.gs-thankyou-dynamic label span,
.gs-thankyou-url span {
    color: var(--gs-foreground);
    font-size: 14px;
    font-weight: 600;
    line-height: 1.35;
}
</style>
